<template>
  <footer>
    <img class="sofa" :src="footerImage" alt />
    <div class="contentBackgound">
      <div class="content">
        <p>©sahani decors 2020</p>
        <div class="codedleaf">
          <p>
            powered by
            <a href="https://codedleaf.in" rel="noopener" target="_blank">
              <span>codedleaf</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MyFooter",
  props: ["footerImage"]
};
</script>

<style scoped lang="scss">
footer {
  flex-shrink: 0;
  overflow: hidden;
  position: relative;
  pointer-events: none;

  img.sofa {
    position: relative;
    z-index: -1;
    width: 200vw;
    @include mediumScreen {
      width: 150vw;
    }
    @include bigScreen {
      width: 100vw;
    }
  }

  .contentBackgound {
    background: $accentPrimaryLight;
    padding-bottom: 4rem;
    .content {
      pointer-events: all;
      display: flex;
      flex-direction: column;
      width: 85vw;
      margin: auto;
      @include mediumScreen {
        flex-direction: row;
        justify-content: space-between;
      }
      .codedleaf {
        a {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
